import { useUserInfo } from "@/api/user";
import { useManageModalConfig } from "@/components/ManageModal/manageConfig";
import NotFoundPage from "@/pages/pages/404";
import { isPermittedSettingsDeepLink } from "@/utils/settingsNavigation";
import { useLocation } from "react-router-dom";

/** Placeholder route target for `/settings/*` deep links; the modal opens via LayoutSettingsShell. */
export function SettingsRouteSync() {
  const location = useLocation();
  const { isLoading: isUserInfoLoading } = useUserInfo();
  const { allMenuItems } = useManageModalConfig();

  if (isUserInfoLoading) {
    return null;
  }

  if (!isPermittedSettingsDeepLink(location.pathname, allMenuItems)) {
    return <NotFoundPage />;
  }

  return null;
}
